import { IToastConfig } from 'src/common/primitives/Toast';

export function generateSuccessToast(firstName: string): IToastConfig {
  return {
    type: 'success',
    title: `${firstName} has been added as a driver!`,
  };
}
